import styled from "styled-components";
import { Button } from "@mui/material";
import { color } from "../styles";
import { ReactNode } from "react";

interface StyledProps {
    children?: ReactNode;
}

export const TitleWrapper = styled.div`
    width: 100%;
    min-height: 40px;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 4px;
`;

export const TitleText = styled.div<StyledProps>`
    font-size: ${props => {
        const text = props.children?.toString() ?? '';
        if (text.length >= 72) return '18px';
        if (text.length >= 63) return '22px';
        return '26px';
    }};
    font-weight: 600;
    line-height: 32px;
    word-wrap: break-word;
    color: ${color.secondary.CHARCOAL};
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SubTitleText = styled.div`
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    word-wrap: break-word;
    color: ${color.secondary.CHARCOAL};
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
`;

export const StyledButton = styled(Button)`
    && {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 14px;
        padding-right: 14px;
        display: flex;
        justify-content: space-between;
        gap: 6px;
        font-size: 14px;
        height: 36px;
        border-radius: 5px;
    }
`;

export const BackButtonStyle = {
    height: "40px",
    width: "40px",
    backgroundColor: "white",
    boxShadow: "0px 4px 9px 0px rgba(16, 47, 67, 0.12)",
    borderRadius: "5px",
};

export const BackButtonRow = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    line-height: 150%;
`;

export const ButtonRow = styled.div`
    display: flex;
    gap: 8px;
`;
